
import Vue from 'vue';
import { AppointmentModel } from '@descomplica/dex-models';
import LiveLessonItem from './LiveLessonItem.vue';

export default Vue.extend({
  components: {
    LiveLessonItem,
  },
  props: {
    appointments: {
      type: Array as Vue.PropType<AppointmentModel[]>,
      required: true,
    },
  },
  computed: {
    formattedLives(): AppointmentModel[] {
      return this.appointments
        .filter((appointment: AppointmentModel) => {
          return appointment.isLive();
        })
        .sort((a: AppointmentModel, b: AppointmentModel) => {
          return a.start > b.start ? 1 : -1;
        });
    },
  },
});
